// extracted by mini-css-extract-plugin
module.exports = {"SampleButton":"Buttons_SampleButton__3Q-1s"};